export default "__VITE_ASSET__BXv32Lsq__"